import {
  getWixCodeGalleryItems,
  getWixCodeAlbumData,
} from './wixCodeDataNormalizer';
import axios from 'axios';
import templatesData from '../config/templatesData';
import { get } from 'lodash';

export const getData = (instanceId, state) => {
  return new Promise(async resolve => {
    try {
      const getAlbumResult = await axios.get(
        `https://www.wix.com/_api/albums-node-server/getAlbum?state=${state}&instanceId=${instanceId}&setItemsLimit=''`,
      );

      let albumData = get(getAlbumResult, 'data.settings');
      const albumGallery = get(getAlbumResult, 'data.sets.gallery');

      const sets = getWixCodeGalleryItems(albumGallery, albumData);
      albumData = getWixCodeAlbumData(albumData, sets);
      resolve({ albumData, sets });
    } catch (e) {
      console.error('Error fetching albums data uou', e);
      resolve(templatesData);
    }
  });
};
